import { Component, OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { PublicService } from 'src/app/servicios/public/public.service';
import { DTConfig } from 'src/app/Class/DTConfig ';
import Swal from 'sweetalert2';
import { ActivatedRoute, Data } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit, OnDestroy {

  public filtroDocumento: FormGroup;
  public procesos: any = []; 
  public subprocesos: any = []; 
  public tipoDocumento: any = [];
  public estamentos: any = [];
  public unidadOrganizativa: any = [];
  public facultades: any = [];
  public programas: any = [];
  public palabraClave: any = [];
  public checklist: any;
  public tipos_formato: any = [];

  public ListadoDocumentos: any = [];
  public DocumentosFiltrados: any = [];
  public serve: string;
  @ViewChildren(DataTableDirective)
  public dtElements: QueryList<DataTableDirective>;
  public dtOptions: DataTables.Settings[] = [DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf];
  public dtTrigger: Subject<any> = new Subject();
  public id : any;
  public filtros : any = { subproceso:{ areas:[] } };
  public detalles : any = {};

 

  constructor( private servi: PublicService, private form: FormBuilder, public route: ActivatedRoute ) {
    this.filtroDocumento = this.form.group({
      categoria: [''],
      subcategoria: [''],
      tipo_documento: [''], 
      estamentos  : [''],
      unidad_organizativa: [''],
      facultades: [''],
      programas: [''],
      palabras_clave: [''],
      entidades:[''],
      formatos:['']
    });
    this.route.params.subscribe(param => {this.id = param['id']});
    this.serve = this.servi.getServe();
    this.servi.GetBusquedaDocumentos()
      .subscribe(data => {
        
        this.procesos = data['procesos'];
        this.tipoDocumento = data['tipoDocumento'];
        this.subprocesos = data['subprocesos'];
        this.estamentos = data['estamentos'];
        this.unidadOrganizativa = data['unidadOrganizativa'];
        this.facultades = data['facultades'];
        this.programas = data['programas'];
        this.palabraClave = data['palabraClave'];
        this.tipos_formato = data['tipos_formato'];

        this.dtTrigger.next();


    });
    if(this.id != null){
      this.checklist = [parseInt(this.id)];
    } 
      
   }
   
  ngOnInit() {
    this.FiltrarDocumentos();
   }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FiltrarDocumentos() {

    if (!this.filtroDocumento.valid) {
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'Verifique los datos e intente nuevamente',
        showConfirmButton: false,
        timer: 1500
      });
    } else {
     
      this.filtroDocumento.value.subcategoria = this.checklist;
      this.servi.GetFiltrarDocumentos(this.filtroDocumento.value)
        .subscribe( (data:any) => {

          data.forEach(e=>{
                e.formato = this.getTipoArchivo(e.ruta);
          });

          this.ListadoDocumentos = data;
          this.DocumentosFiltrados = data;
          this.rerender();
        });      
    }
  }
  

 
  rerender(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    });
  }
  
  openModalArchivo(dato) {
    this.detalles = dato; 
    $('#ModalVerArchivo').modal('show');
  }

  getTipoArchivo(str){

    if( str )
    {
      str = str.toLowerCase(); 
      if( str.includes('.pdf') )
      {
        return "pdf";
      }
      else if( str.includes('.doc') || str.includes('.docx') )
      {
        return "word";
      }
      else if( str.includes('.xlsx') || str.includes('.xls') )
      {
        return "excel";
      }

    }

  }

  filtrarProceso(s){
    this.filtros.subproceso = s;
    this.filtros.area = null;
    this.filtrar();
  }

  filtrar()
  {
  
    var list = this.ListadoDocumentos; 
    
    if( this.filtros.subproceso.nombre )
    {
      list = list.filter(e => e.subcategoria == this.filtros.subproceso.nombre );
    }

    if( this.filtros.area )
    {
      list = list.filter(e => e.area == this.filtros.area );
    }

    if( this.filtros.tipo_documento )
    {
      list = list.filter(e => e.tipo_documento_nombre == this.filtros.tipo_documento );
    }

    if( this.filtros.estamento )
    {
      list = list.filter(e => e.estamentos.includes(this.filtros.estamento) );
    }

    if( this.filtros.facultad )
    {
      list = list.filter(e => e.facultades.includes(this.filtros.facultad) );
    }

    if( this.filtros.programa )
    {
      list = list.filter(e => e.programas.includes(this.filtros.programa) );
    }

    if( this.filtros.unidad )
    {
      list = list.filter(e => e.unidades.includes(this.filtros.unidad) );
    }

    if( this.filtros.palabra )
    {
      list = list.filter(e => e.palabras_clave.includes(this.filtros.palabra) );
    }
   
    this.DocumentosFiltrados = list;
    this.rerender();

  }

  limpiar() {
    this.filtros = { subproceso:{ areas:[] } }; 
    this.DocumentosFiltrados = this.ListadoDocumentos;
    this.rerender();
  }


}
